var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success_container"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require('@/assets/img/ok.png'),"alt":""}}),_c('p',[_vm._v("提交成功")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }